// Charge la base commune
import './common.js'

// Styles custom
import './scss/pages/realEstateSearch.scss'

// Real Estate Search Form
async function getRESForm ($f) {
  $f.load()
  import(/* webpackChunkName: "realEstateSearchForm", webpackPrefetch: true */ './js/components/realEstateSearchForm.js').then(() => {
    /* global Waypoint */
    Waypoint.refreshAll()
    $f.load(false)
  })
}

// Contact Form
async function getCForm ($f) {
  $f.load()
  import(/* webpackChunkName: "contactForm", webpackPrefetch: true */ './js/components/contactForm.js').then(() => {
    Waypoint.refreshAll()
    $f.load(false)
  })
}

// Pajination
async function getPajination () {
  import(/* webpackChunkName: "pajination", webpackPrefetch: true */ './js/components/pajination.js').then(() => {
    Waypoint.refreshAll()
    // sur changement de page, on se repositionne sur le début de listing
    $('ul.pagination > li > a').off().on('click', function () {
      const h = $('#header').height()
      const p = $(this).parents('.pajinate-nav').height()
      $('html').animate({ scrollTop: $('#all-offers').offset().top - h - p - 10 }, { duration: 200, easing: 'linear' })
    })
  })
}

// Masonry
async function getMasonry () {
  import(/* webpackChunkName: "masonry" */ './js/components/masonry.js').then(() => {
    Waypoint.refreshAll()
  })
}

// actions principales communes à toutes les pages
$(document).ready(function () {
  // formulaire de tri ou du nombre d'éléments affichables
  $('form[name="redForm"] select').on('change', function () {
    $(this).parents('form').submit()
  })

  // alertes bootstrap
  const $a = $('.alert')
  if ($a.length) {
    $a.waypoint(function () {
      import(/* webpackChunkName: "alertBs" */ './scss/components/alertBs.scss')
      this.destroy()
    }, {
      offset: '100%'
    })
  }

  // gestion du formulaire de recherche des biens immobiliers
  const $resf = $('.resform:not(.modal)')
  if ($resf.length) {
    $resf.waypoint(function () {
      getRESForm($resf)
      this.destroy()
    }, {
      offset: '100%'
    })
  }

  // formulaire de contact
  const $cf = $('form[name="cForm"]')
  $cf.waypoint(function () {
    getCForm($cf)
    this.destroy()
  }, {
    offset: '100%'
  })

  // gestion des pages
  const $p = $('.pajinate')
  if ($p.length) {
    $p.waypoint(function () {
      getPajination()
      this.destroy()
    }, {
      offset: '100%'
    })
  }

  // gestion du masonry
  const $g = $('.grid')
  if ($g.length) {
    $g.waypoint(function () {
      getMasonry()
      this.destroy()
    }, {
      offset: '100%'
    })
  }

  if ($('#go').length) {
    const t = $('#go')
    $('html, body').animate({ scrollTop: ($(t).offset().top - $('#header').height() - 50) })
  }

  const $mn = $('#filters-nav')
  const $h = $('#header')
  $h.find('.navbar-toggler, .navbar-close').on('click', function () {
    if ($h.find('.navbar-collapse').hasClass('show')) { $mn.parents('.sticky-top').css('z-index', '999') } else { $mn.parents('.sticky-top').css('z-index', '1020') }
  })
  $mn.find('.navbar-toggler, .navbar-close').on('click', function () {
    if ($mn.find('.navbar-collapse').hasClass('show')) {
      $mn.parents('.sticky-top').css('z-index', '1020')
      $('body').addClass('open')
    } else {
      $mn.parents('.sticky-top').css('z-index', '999')
      $('body').removeClass('open')
    }
  })
})
